/**
 * Metadados leves de arquivo para o preview de anexo (tamanho / páginas PDF).
 */
export function formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function isPdfFile(file: File): boolean {
    return (
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
    );
}

/** Contagem de páginas via /Count do catálogo PDF (best-effort, sem pdf.js). */
export async function readPdfPageCount(file: File): Promise<number | null> {
    if (!isPdfFile(file)) return null;
    try {
        const slice = file.slice(0, Math.min(file.size, 1_500_000));
        const text = new TextDecoder('latin1').decode(await slice.arrayBuffer());
        const pagesObj = text.match(/\/Type\s*\/Pages\b[\s\S]{0,200}?\/Count\s+(\d+)/);
        if (pagesObj?.[1]) return Number(pagesObj[1]);
        const counts = [...text.matchAll(/\/Count\s+(\d+)/g)].map((m) => Number(m[1]));
        const max = counts.length ? Math.max(...counts) : 0;
        return max > 0 ? max : null;
    } catch {
        return null;
    }
}
